<template>
  <router-view />
</template>

<script>
  import { mapGetters } from 'vuex';
  
  import router, { pages } from '@/router';
  import OnePage from '@/layouts/onePage.vue';
  import MultiPage from '@/layouts/multiPage.vue';

  const multiPageRoutes = pages.map(name => ({
    path: `/${name === 'tour360' ? '360-tour' : name}/:id`,
    name,
    component: MultiPage
  }));

  const onePageRoute1 = {
    path: '/',
    name: 'onePage',
    component: OnePage
  };
  
  const onePageRoute2 = {
    path: '/:id',
    name: 'onePage',
    component: OnePage
  };

  export default {
    computed: {
      ...mapGetters('tour', ['getSPA'])
    },
    created() {
      if (this.getSPA) {
        router.addRoute(onePageRoute1);
        router.addRoute(onePageRoute2);
      } else {
        multiPageRoutes.forEach(route => router.addRoute(route));
      }
    }
  };
</script>

<style src="../../layouts/styles.scss" lang="scss"></style>
